import React from "react";
import { cn } from "../../../../shadcn/lib/utils";

interface BuyerTimerDisplayProps {
  hours: number;
  minutes: number;
  seconds: number;
  status: string;
  endTime?: number;
  extendTimeAt?: string;
}

export default function BuyerTimerDisplay({
  hours,
  minutes,
  seconds,
  status,
  endTime,
  extendTimeAt,
}: BuyerTimerDisplayProps) {
  const formatTime = () => {
    if (status !== "live") {
      return "00:00:00";
    }
    const h = hours < 10 ? `0${hours}` : String(hours);
    const m = minutes < 10 ? `0${minutes}` : String(minutes);
    const s = seconds < 10 ? `0${seconds}` : String(seconds);
    return `${h}:${m}:${s}`;
  };

  const getTimerColor = () => {
    if (status !== "live" || !endTime) {
      return "timer-gray";
    }

    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    const extendTimeSeconds = extendTimeAt ? parseInt(extendTimeAt) * 60 : 300;
    const redThreshold = 240;
    const orangeThreshold = Math.max(2400, extendTimeSeconds);

    if (totalSeconds <= redThreshold) return "timer-red";
    if (totalSeconds <= orangeThreshold) return "timer-orange";
    return "timer-green";
  };

  return (
    <div className="w-full sm:w-auto text-left sm:text-right">
      <div className="text-[10px] sm:text-[11px] text-gray-500 mb-0.5">
        Time Left
      </div>
      <div
        className={cn(
          "text-[22px] sm:text-[24px] font-bold px-2 py-0.5 rounded-md block w-full sm:inline-block sm:w-auto min-w-0 sm:min-w-[122px] text-center border",
          {
            "bg-green-50 text-green-700 border-green-200": getTimerColor() === "timer-green",
            "bg-orange-50 text-orange-600 border-orange-200": getTimerColor() === "timer-orange",
            "bg-red-50 text-red-700 border-red-200 animate-pulse": getTimerColor() === "timer-red",
            "bg-gray-50 text-gray-500 border-gray-200": getTimerColor() === "timer-gray",
          },
        )}
      >
        {formatTime()}
      </div>
    </div>
  );
}
